"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon/icon"));

var _utils = require("../lib/utils");

var SmallMessageBox = function SmallMessageBox(_ref) {
  var primaryText = _ref.primaryText,
      icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-mbx-small"
  }, (0, _utils.isObject)(icon) && icon !== null && ( /*#__PURE__*/_react["default"].isValidElement(icon) ? /*#__PURE__*/_react["default"].cloneElement(icon, {
    className: (0, _utils.gatherClasses)(null, "oui-mbx-icon", icon.props.className),
    size: "sm",
    width: null,
    height: null
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-mbx-icon"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({}, icon, {
    width: "16px",
    height: "16px",
    className: (0, _utils.gatherClasses)(null, icon.className || "")
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-mbx-text-primary"
  }, primaryText));
};

SmallMessageBox.defaultProps = {
  primaryText: ""
};
SmallMessageBox.propTypes = {
  icon: _propTypes["default"].object,
  primaryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])
};
SmallMessageBox.displayName = "OrionMessageBoxSmall";
var _default = SmallMessageBox;
exports["default"] = _default;